import { Component, Inject } from '@angular/core';

import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-alerte-modal',
    imports: [MatDialogModule, MatButtonModule, MatIconModule, MatDividerModule, DragDropModule],
    templateUrl: './alerte-modal.component.html',
    styleUrls: ['./alerte-modal.component.scss']
})
export class AlerteModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
